<template>
  <div class="card card-body rounded-top">
    <component-table
      entityType="exam_result"
      addButtonEntityType="team"
      :addButtonEntityId="teamId"
      :actions="actions"
      :columns="columns"
      :data="list"
      :total="count"
      :hideSearchInput="true"
      @add="showAddModal"
      @edit="showEditModal($event.id)"
      @delete="showDeleteDialog($event.id)"
    />

    <exam-result-modal
      :show="showModal"
      :id="idToEdit"
      @save="add"
      @close="hideModal"
      @update="update"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';

import ComponentTable from '@/components/table/Table';
import { listMixin } from '@/mixins/list';
import { EDIT_ACTION, DELETE_ACTION } from '@/utils/constants';
import ExamResultModal from '@/components/modals/ExamResultModal';
import { time } from '@/filters/time';
import { ExamUnitType } from '@/enums/examUnitType.enum';

// @vuese
// Lista wyników egzaminu
// @group Exam
export default {
  mixins: [
    listMixin('exam/results', {
      listError: 'messages.examResult.listError',
      getError: 'messages.examResult.getError',
      added: 'messages.examResult.added',
      addError: 'messages.examResult.addError',
      updated: 'messages.examResult.updated',
      updateError: 'messages.examResult.updateError',
      deleteConfirm: 'messages.examResult.deleteConfirm',
      deleted: 'messages.examResult.deleted',
      deleteError: 'messages.examResult.deleteError'
    })
  ],
  props: {
    // Czy wyniki zawodnika
    playerResults: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  components: { ComponentTable, ExamResultModal },

  data() {
    return {
      actions: [
        { ...EDIT_ACTION, entityType: 'examResult' },
        { ...DELETE_ACTION, entityType: 'examResult' }
      ]
    };
  },
  computed: {
    ...mapState({
      list: state =>
        state.exam.results.list.map(examResult => {
          examResult.firstName = examResult.profile.firstName;
          examResult.lastName = examResult.profile.lastName;
          examResult.examName = examResult.exam.name;
          examResult.dateFormated = moment(examResult.date).format('DD-MM-Y');
          examResult.scoreFormated =
            examResult.exam.unit === ExamUnitType.TIME ? time(examResult.score) : examResult.score;

          return examResult;
        }),
      count: state => state.exam.results.count
    }),
    teamId() {
      return this.$route.params.teamId;
    },

    columns() {
      const columns = [
        {
          name: 'dateFormated',
          displayName: 'columns.date',
          sortable: true,
          sortName: 'date'
        },
        {
          name: 'scoreFormated',
          displayName: 'columns.score',
          sortable: this.playerResults ? false : true,
          sortName: 'score'
        }
      ];

      if (this.playerResults) {
        columns.push({
          name: 'examName',
          displayName: 'columns.exam',
          sortable: false
        });
      } else {
        columns.unshift(
          {
            name: 'firstName',
            displayName: 'columns.firstName'
          },
          {
            name: 'lastName',
            displayName: 'columns.lastName'
          }
        );
      }
      return columns;
    }
  }
};
</script>
